import { useMutation } from '@tanstack/react-query';
import { POST, POST_WARRANTY_ADD } from '../../../../services';
import { openAlert } from '../../../../components/alert/hooks';
import { InsertWarranty } from '../../../../resources/payload';

export const onUploadFile = ({ reset }) =>
  useMutation({
    mutationFn: async (values) => {
      const formData = new FormData();
      const payload = InsertWarranty(values);

      Object.entries(payload).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
          formData.append(key, value);
        }
      });

      const response = await POST(POST_WARRANTY_ADD(), formData);
      return response;
    },
    onSuccess: (res) => {
      openAlert({ model: 'message', type: 'success', message: res?.message });
      reset({
        ...res,
      });
    },
    onError: (error) => {
      openAlert({ model: 'message', type: 'error', message: error?.message });
    },
  });
